module.exports = __webpack_public_path__ + "static/media/AIWorkshopBG.301c8669.svg";